import { WaiterHelpItemNumber, WaiterHelpModalContainer, WaiterHelpModalItems, WaiterHelpModalItemsTotal, WaiterHelpPoint } from './style';
import { Button } from 'takeat-design-system-ui-kit';

import img from '../../assets/img/IconQuestion.svg';
import useWaiterHelp from '~/hooks/waiterHelp';
import React from 'react';

export default function WaiterHelpModal() {
  const { handleCheckTicket, waiterTickets } = useWaiterHelp();
  
  const gdTickets = waiterTickets
    .filter(ticket => ticket?.type === 'gd')
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  
  const currentGdTicket = gdTickets && gdTickets[0];
  const data = currentGdTicket?.data;
  const comment = currentGdTicket?.comment;
  const buyer = currentGdTicket?.buyer;
  const table_number = currentGdTicket?.command_table_number;

  return <WaiterHelpModalContainer open={!!currentGdTicket}>
    <div>
      <header>
        <img src={img} alt="" />
        <div>
          <p>Mesa {table_number} está solicitando ajuda.</p>
          <span>{buyer?.phone} - {buyer?.name}</span>
        </div>
      </header>
      <main>
        {data?.length > 0 && <div>
          <span>Itens solicitados</span>
          <WaiterHelpModalItemsTotal>
            {data?.map(element => <div>
              {(element.action_type === 'multiple') ? <>
                <WaiterHelpItemNumber>{element?.number}x</WaiterHelpItemNumber>
                {element?.name}
              </> : <>
                <WaiterHelpPoint/>
                {element?.name}
              </>}
            </div>)}
          </WaiterHelpModalItemsTotal>
        </div>}
        {comment && <div>
          <span>Mensagem</span>
          <WaiterHelpModalItems>
            {comment}
          </WaiterHelpModalItems>
        </div>}
      </main>
      <footer>
        <Button style={{ width: '100%' }} onClick={handleCheckTicket}>Ok, ciente</Button>
      </footer>
    </div>
  </WaiterHelpModalContainer>
}